import update from "immutability-helper";
import { format } from "date-fns";
import { formatCallerNumber } from "./filters";

export const replaceTextWithCustomerInfo = (templateData: any, data: any) => {
  const templateFields = [
    { id: 1, contents: "고객명" },
    { id: 2, contents: "차트번호" },
    { id: 3, contents: "생년월일" },
    { id: 4, contents: "주민번호" },
    { id: 5, contents: "전화번호" },
    { id: 6, contents: "주소" },
    { id: 7, contents: "작성일자" },
  ];

  const fieldMapping: Record<string, (data: any) => string> = {
    고객명: ({ customer }) => customer.name || "-",
    차트번호: ({ customer }) => customer.chartNo || "-",
    생년월일: ({ customer }) => customer.birthday || "-",
    주민번호: ({ customer }) => {
      const ssn = customer.ssnHead || "";
      if (!ssn) return "";
      const ssnStr = ssn.toString();
      const lastNumbers = customer.divisionNumber || "";
      if (ssnStr.length >= 6) {
        const front6 = ssnStr.slice(0, 6);
        return `${front6}-${lastNumbers}`;
      } else {
        return ssnStr;
      }
    },
    전화번호: ({ customer }) => formatCallerNumber(customer.phoneNumber),
    주소: ({ customer }) => {
      const fullAddress = `${customer.address || ""} ${
        customer.addressDetail || ""
      }`.trim();
      return fullAddress || "";
    },
    작성일자: () => {
      return format(new Date(), "yyyy-MM-dd");
    },
  };

  const updatedData = update(templateData, {});

  updatedData.objects = updatedData.objects.map((obj: any) => {
    if (obj.type !== "i-text") {
      return obj;
    }

    const matchedField = templateFields.find(
      (field) => field.contents === obj.text
    );

    if (matchedField) {
      const valueFunction = fieldMapping[matchedField.contents];
      const customerValue = valueFunction ? valueFunction(data) : "";

      return {
        ...obj,
        text: customerValue,
      };
    }

    return obj;
  });

  return updatedData;
};
